var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-radio",attrs:{"disabled":_vm.disabled},on:{"click":_vm.radioClick}},[_c('input',{attrs:{"type":"radio","disabled":_vm.disabled},domProps:{"checked":_vm.checkValue}}),_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }